module.exports = __webpack_public_path__ + "assets/normal/images/icon-department-member.962b6ed0.png";